import React, { ReactElement } from 'react';
import FormFieldUpload from '../form-field-upload/form-field-upload.component';
import useStylesImageLargeFormFieldUpload from './image-large-form-field-upload.styles';
import { FILE_EXTENSION_LIST_IMAGE } from '../../constants/system/file-extensions';

const ImageLargeFormFieldUpload: ReactMemoComponent = React.memo((props: ReactComponentProps): ReactElement => {
  const {
    name,
    uploadFile,
    buttonLabel,
    defaultPreviewUrl,
    onFileChange,
    onFileDelete,
  } = props;

  const { classes } = useStylesImageLargeFormFieldUpload();

  return (
    <FormFieldUpload
      isImage
      isDroppable
      name={name}
      uploadFile={uploadFile}
      dropTargetBoxClassName={classes.dropTargetBox}
      previewImageClassName={classes.previewImage}
      buttonLabel={buttonLabel}
      defaultPreviewUrl={defaultPreviewUrl}
      acceptedExtensionList={FILE_EXTENSION_LIST_IMAGE}
      onFileChange={onFileChange}
      onFileDelete={onFileDelete}
    />
  );
});

export default ImageLargeFormFieldUpload;
